/**
 * 자산은 별도 업로드로 관리되므로 배포 전에 아래 URL 이 실제로 응답하는지 확인해야 한다.
 */
export const CREVERSE_HEAD = {
  title: '매쏠로지',
  favicon: 'https://frontend-assets.mathflat.com/teacher/assets/creverse/favicon.ico',
  appleTouchIcon:
    'https://frontend-assets.mathflat.com/teacher/assets/creverse/apple-touch-icon.png',
} as const
